import React from "react";
import MessageActionButtons from "./message_action_buttons.jsx";
import { useChatContext } from "../chat_context.jsx";

export default function LastAiMessage() {
  const {
    toAddInTheHistory,
    history,
    setHistory,
    setToAddInTheHistory,
    setIsStreaming,
    setCurrentQuestion,
  } = useChatContext();

  if (!toAddInTheHistory || !toAddInTheHistory.answer) {
    return null;
  }

  return (
    <div className="d-flex justify-content-start">
      <div className="d-flex align-items-start w-100">
        <div className="bg-light rounded px-3 py-2 flex-grow-1">
          <div
            className="text-break"
            dangerouslySetInnerHTML={{
              __html: toAddInTheHistory.answer,
            }}
          />
          <MessageActionButtons
            answer={toAddInTheHistory}
            history={history}
            setHistory={setHistory}
            toAddInTheHistory={toAddInTheHistory}
            setToAddInTheHistory={setToAddInTheHistory}
            setIsStreaming={setIsStreaming}
            setCurrentQuestion={setCurrentQuestion}
          />
        </div>
      </div>
    </div>
  );
}

